<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i1RHCc/tc-custom/9780062424815.jpg?1726455549294" alt="This image is the cover for the book Girl in the Dark"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Girl in the Dark
      </h1>
      <p class="bookDescription body article font2">
        <p>An award-winning, internationally bestselling author makes her American debut with this taut, riveting domestic drama with the compulsive intensity of <i>The Good Girl, The Pocket Wife,</i> and <i>The Stranger</i>, about a long-lost brother convicted of a horrifying crime and a sister’s fight to clear his name.</p><p>A single mother and lawyer, Iris has a colorful caseload, a young son with behavior issues, and a judgmental mother.</p><p>She also has a brother—shocking news she uncovers by accident. Why did her mother lie to her for her entire life? Why did she hide the existence of Ray Boelens from her?</p><p>Curious about this sibling she has never known, Iris begins to search for long-buried truths. What she discovers surprises—and horrifies—her. Her older brother is autistic—and in prison for brutally murdering his neighbor and her daughter.</p><p>Visiting Ray, she meets a man who looks heartbreakingly like her own son. A man who is devoted to his tropical fish and who loves baking bread. A man whose naiveté unnerves her. There is no question that Ray is odd and obsessive, unable to communicate like the rest of us. But is he really a killer?</p><p>Told in the alternative voices of Ray and Iris, <i>Girl in the Dark</i> is a compulsive, page-turning thriller about lies, murder, and the tenacity of a family determined to stay together even as they are pulled apart at the most vulnerable seams.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marion Pauw
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a60fc41c